import React from "react";
import { GatsbyBrowser } from "gatsby";
import LayoutProvider from "../../src/LayoutProvider";

export default (({ element, props }) => (
  <LayoutProvider props={props} element={element} />
)) as GatsbyBrowser["wrapPageElement"];
